import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { MapDispatchToProps, MapStateToProps } from '~commonInfra/utils/ConnectUtils';
import { siteUrlsSelector } from '~src/bootstrap/redux/selectors/SiteUrlsSelectors';
import { requestSpaceContents } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';

import { AppState } from '../../bootstrap/redux/state/AppState';
import { RecentsSpace, RecentsSpaceDispatchProps, RecentsSpaceOwnProps, RecentsSpaceStateProps } from './RecentsSpace';

const mapStateToProps: MapStateToProps<RecentsSpaceStateProps> = (state: AppState) => ({
  urls: siteUrlsSelector(state)
});

const mapDispatchToProps: MapDispatchToProps<RecentsSpaceDispatchProps> = (dispatch) => bindActionCreators({
  requestSpaceContents,
}, dispatch);

export const ConnectedRecentsSpace: React.ComponentClass<RecentsSpaceOwnProps>
  = connect(mapStateToProps, mapDispatchToProps)(RecentsSpace);
